<div class="container" dir="rtl">
  <div *ngIf="report?.ElectricalScore" class="container">
    <ng-container *ngIf="report?.ElectricalScore !== -1">
      <div class="report-card">
        <p class="report-text text-center">{{report?.ProblemCategory}}</p>
        <div class="score-section py-4">
          <div class="score-number">
            <small>100 /</small>
            {{ report?.ElectricalScore }}
          </div>

          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="report?.ElectricalScore"></div>
          </div>

          <div class="text-center pt-4">
            <span
              class="status-badge"
              [ngClass]="{
                'good': report?.ElectricalScore >= 70,
                'medium': report?.ElectricalScore >= 40 && report?.ElectricalScore < 70,
                'bad': report?.ElectricalScore < 40
                }">
              {{ report?.ElectricalLevel }}
            </span>
          </div>
        </div>

        <div class="report-section">
          <h3>گزارش تحلیل</h3>
          <div class="report-text">
            {{ report?.DiagnosticReport }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
